import { $api } from '../y/api';
import { $fn } from '../y/fn';
import { YId, YObjectId } from '../y/types';
import { the_user } from './login';

export function meHideFriend(id: YId) {
    return $api.POST(`user/${the_user!.id}/friend/${id}/hide`);
}

export function meUnhideFriend(id: YId) {
    return $api.POST(`user/${the_user!.id}/friend/${id}/unhide`);
}

export interface MEFriendModel {
    id: YId;
    first_name: string;
    last_name: string;
    avatar?: YId;
    booked_events: YObjectId[];
    booked_sessions: YObjectId[];
    hidden: boolean;
}

export class MEFriends {
    private _models: MEFriendModel[];
    private _by_event: { [event_id: YObjectId]: MEFriendModel[] | undefined }
    private _by_session: { [session_id: YObjectId]: MEFriendModel[] | undefined }

    constructor(models: MEFriendModel[]) {
        models.sort((a, b) => $fn.ICOMPARE(a.first_name + a.last_name, b.first_name + b.last_name));
        this._models = models;
        this._by_event = {};
        this._by_session = {};
        const by_event = this._by_event;
        const by_session = this._by_session

        for(const f of models) {
            for(const e of f.booked_events) {
                if(by_event[e])
                    by_event[e]!.push(f);
                else
                    by_event[e] = [f];
            }

            for(const s of f.booked_sessions) {
                if(by_session[s])
                    by_session[s]!.push(f);
                else
                    by_session[s] = [f];
            }
        }
    }

    get all() {
        return this._models;
    }

    byEvent(event_id: YObjectId | YId) {
        return this._by_event[event_id as YObjectId];
    }
}

let friends_promise: Promise<MEFriends> | undefined;
export function meGetFriends(reload?: boolean) {
    if(!friends_promise || reload)
        friends_promise = $api.GET<MEFriendModel[]>('me/friends').then(models => new MEFriends(models));
    return friends_promise;
}
